import { States } from './formSelectOptions';

// Helper function to handle facility selection
export const handleFacilitySelected = (facilityData, setValue, stateSelectRefs) => {
  
  // Extract sectionId from facility data
  const sectionId = facilityData.sectionId;
  
  // Use index as the prefix when using useFieldArray
  const fieldPrefix = `facilities.${sectionId}`;
  
  // Update form fields with facility data using the appropriate field prefix
  setValue(`${fieldPrefix}.hco_entity_id`, facilityData.id || '');
  setValue(`${fieldPrefix}.facilityName`, facilityData.name || '', { shouldValidate: true });
  setValue(`${fieldPrefix}.address`, facilityData.address || '', { shouldValidate: true });
  setValue(`${fieldPrefix}.city`, facilityData.city || '', { shouldValidate: true });
  
  // Special handling for state dropdown
  if (facilityData.state) {
    
    // Set the value in react-hook-form
    setValue(`${fieldPrefix}.state`, facilityData.state, { shouldValidate: true });
    
    // Update the CustomSelect component using the corresponding ref
    if (stateSelectRefs && stateSelectRefs[sectionId]) {
      stateSelectRefs[sectionId].setValue(facilityData.state);
    }
    
    // Also try to manually update the native select for backward compatibility
    const selector = `select[name="${fieldPrefix}.state"]`;
    const stateSelect = document.querySelector(selector);
    if (stateSelect) {
      stateSelect.value = facilityData.state;
      // Create and dispatch a native change event
      const event = new Event('change', { bubbles: true });
      stateSelect.dispatchEvent(event);
    }
  }
  
  setValue(`${fieldPrefix}.zipCode`, facilityData.zip || '', { shouldValidate: true });
  setValue(`${fieldPrefix}.phoneNumber`, facilityData.phone || '', { shouldValidate: true });
};

// Event listener setup for facility selection
export const setupFacilityListener = (setValue, stateSelectRefs) => {
  
  // Set up listeners for each facility section
  const listeners = [];
  
  // Create listeners for up to 6 facility sections (based on the limit in the code)
  for (let sectionId = 0; sectionId <= 5; sectionId++) { // Use 0-based indexing for useFieldArray
    const eventName = `facility:selected:${sectionId}`;
    const listener = (event) => {
      handleFacilitySelected(event.detail, setValue, stateSelectRefs);
    };
    document.addEventListener(eventName, listener);
    listeners.push({ name: eventName, handler: listener });
  }
  
  // Also maintain the global listener for backward compatibility
  const globalListener = (event) => {
    handleFacilitySelected(event.detail, setValue, stateSelectRefs);
  };
  document.addEventListener('facility:selected', globalListener);
  listeners.push({ name: 'facility:selected', handler: globalListener });
  
  // Return a cleanup function that removes all listeners
  return () => {
    listeners.forEach(({ name, handler }) => {
      document.removeEventListener(name, handler);
    });
  };
}; 